<template>
    <div>
        <input type="file" @change="uploadImage" accept="image/gif, image/jpeg, image/png" class="d-none">
        <div class="d-flex flex-column align-items-center">
            <img :src="imagePath" alt="" width="200px">
            <button class="ds-btn mt-3" type="button" @click="pickImage" :disabled="isProcessing">
                Izvēlēties logo
            </button>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        name: 'image-upload',
        props: {
            image: {
                type: String,
            },
        },
        data() {
            return {
                imagePath: this.image || '/img/logo-placeholder.png',
                isProcessing: false,
            }
        },
        methods: {
            pickImage() {
                this.$el.querySelector('input').click();
            },
            async uploadImage(e) {
                const [image] = e.target.files;

                if (!image) {
                    return;
                }

                this.isProcessing = true;

                const formData = new FormData;
                formData.append('image', image);

                const {data: {imagePath, success}} = await axios.post('/api/uploads/image', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                });

                if (!success) {
                    return alert('Kaut kas nogāja greizi.');
                }

                this.imagePath = '/' + imagePath;
                this.$emit('uploaded', this.imagePath);

                this.isProcessing = false;
                e.target.value = '';
            },
        }
    }
</script>